module.exports = __webpack_public_path__ + "img/partly-cloudy-day.d8947ea1.svg";